import React from 'react';
import styles from './ContactPage.module.css';

const ContactPage = () => {
    return (
        <main className={styles.contactPageContainer}>
            <section className={styles.contentSection}>
                <h1 className={styles.pageTitle}>Contact Us</h1>
                <div className={styles.contactCard}>
                    <p className={styles.introText}>
                        If you have any questions or need further assistance, please feel free to reach out to us using the contact information below.
                    </p>

                    <div className={styles.contactMethods}>
                        <div className={styles.contactMethod}>
                            <div className={styles.iconWrapper}>✉️</div>
                            <h3>Email</h3>
                            <a href="mailto:it@highviewhouse.org" className={styles.contactLink}>
                                it@highviewhouse.org
                            </a>
                        </div>

                        <div className={styles.contactMethod}>
                            <div className={styles.iconWrapper}>📞</div>
                            <h3>Phone</h3>
                            <a href="tel:+14044929674" className={styles.contactLink}>
                                (404) 492-9674
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default ContactPage;
